// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__CdG35","studio":"studio__waaxd"};